module.exports = __webpack_public_path__ + "static/media/beko.f56ef9af.svg";